var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
export function chapeauStyle(_a) {
    var inverted = _a.inverted;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: uppercase;\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: uppercase;\n  "])), inverted ? tokens.colors.pink : tokens.colors.navy, tokens.fontSizes.small, tokens.fontWeights.bold, tokens.lineHeights.default, tokens.letterSpacing.relaxed);
}
var templateObject_1;
